import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { productGallery as proxyCard } from '../lib/imageProxy';
import BlurImage from './BlurImage';
import { formatPrice } from '../utils/format';
import useLocale from '../hooks/useLocale';
import { trackArtistProductClick } from '../services/analyticsService';

const ArtistGalleryFigure = ({ product, artistId, artistSlug }) => {
  const { t } = useTranslation('artist');
  const locale = useLocale();

  const isSoldOut = Boolean(product.isSoldOut);
  const isPreorder = Boolean(product.isPreorder);

  const statusTag = isSoldOut
    ? t('page.figure.soldOut')
    : isPreorder
    ? t('page.figure.preorder')
    : null;
  const seriesLabel = product.series && product.series !== 'N/A' ? product.series : null;

  const rawPrice = product.price && !isNaN(product.price) ? Number(product.price) : null;
  const displayPrice = rawPrice !== null
    ? (isPreorder
        ? (product.preorderPrice != null && product.preorderPrice !== ''
            ? Number(product.preorderPrice)
            : rawPrice * 0.5)
        : rawPrice)
    : null;

  const productUrl = `/product/${product.slug || product.id}`;

  const handleClick = () => {
    trackArtistProductClick(product.id, product.name, artistId, artistSlug);
  };

  return (
    <figure className={`artist-figure${isSoldOut ? ' is-soldout' : ''}`}>
      <Link
        to={productUrl}
        className="artist-figure-link"
        aria-label={t('page.figure.open', { name: product.name })}
        onClick={handleClick}
      >
        <div className="artist-figure-image-wrap">
          <div className="artist-figure-image">
            <BlurImage
              src={proxyCard(product.image)}
              alt={product.name}
              loading="lazy"
              objectFit="contain"
              onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }}
            />
          </div>
          {statusTag && (
            <span className={`artist-figure-status${isSoldOut ? ' is-soldout' : ' is-preorder'}`}>
              {statusTag}
            </span>
          )}
        </div>

        <figcaption className="artist-figure-caption">
          <span className="artist-figure-title">{product.name}</span>
          {seriesLabel && (
            <span className="artist-figure-meta">
              {t('page.figure.seriesMeta', { name: seriesLabel })}
            </span>
          )}
          {displayPrice !== null && (
            <span className="artist-figure-price">
              {formatPrice(displayPrice, 'MXN', locale)}
              {isPreorder && (
                <span className="artist-figure-price-note">{t('page.figure.deposit')}</span>
              )}
            </span>
          )}
          <span className={`artist-figure-cta${isSoldOut ? ' is-soldout' : ''}`}>
            {isSoldOut ? t('page.figure.soldOut') : t('page.figure.viewProduct')}
          </span>
        </figcaption>
      </Link>
    </figure>
  );
};

export default ArtistGalleryFigure;
